import { Component, Inject, OnInit, EventEmitter } from '@angular/core';
import { HandlerModal } from '../../handler-modals';
import { DAyudasFormularioNoExperto } from '../../../../../../configuracion/dayudas-formulario-no-experto';
import { MAT_DIALOG_DATA,MatDialogRef } from '@angular/material';
import { DDocumento } from '@dian/api-formulario';
import { DirectionType } from '../../handler-modals';
import { DOperacionesMatematicasServicio, DTipoOperacionAritmetica } from '@dian-cmp/formulario';
import { DNotificacionServicio } from '@dian-cmp/notificaciones';
import { ComponentFactoryService } from '../../../../../../services/component-factory.service';
import { SugeridaSingletonService } from '../../../../../../services/sugerida.service';

const VAL_INDICADOR_COMPLETO="999";//Valor de referencia, si el indicador esta en este valor entonces ya paso todos los steps y el modal esta completo
const ID_CAS_INDICADOR_AVANCE='cs_id_229';

const stepsList = [
/*   { text: "1", active: false, completed: false, tooltip: 'Valor Bienes Inmuebles Leasing', listHelp: ['158']}, */
  { text: "1", active: true, completed: false, tooltip: 'Lista de Bienes Inmuebles No Leasing', listHelp: ['338'] }
];

const tableStructure = [
    {id: 'informante', title: 'Informante'}, 
    {id: 'origen', title: 'Origen información'}, 
    {id: 'actividadNombre', title: 'Actividad'}, 
    {id: 'valor', title: 'Valor'},
];


class Form1 {
  id: number;
  informante: string;
  origen: string;
  actividad: string;
  actividadNombre: string;
  valor: string;
  retencion:string;
  devoluciones:string;
  controlSugeridaForm: ControlSugeridaForm;
}
class ControlSugeridaForm{
  numNitReportante: string;
  grupos:Array<ControlGrupoVariables>;
}
class ControlGrupoVariables{
  idGrupo:number;
  variable:string;
}

class ArticulosDominio {
  valor: number;
  nombre: string;
}

@Component({
  selector: 'app-ingresos-comerciante-modal',
  templateUrl: './ingresos-comerciante-modal.component.html',
  styleUrls: ['./ingresos-comerciante-modal.component.css'],
  providers: [
    DNotificacionServicio,
    DOperacionesMatematicasServicio,
    ComponentFactoryService
  ]
})
export class IngresosComercianteModalComponent extends HandlerModal implements OnInit {

  public dataSourceHeader = tableStructure;
  public dataSourceBody = [];
  public modelForm: Form1 = new Form1();
  public lstArticulos: ArticulosDominio[] = [];
  public lstAnios: number[] = [];

  public OPERACION_NULA:number = 0;
  public OPERACION_AGREGAR:number = 1;
  public OPERACION_EDITAR:number = 2;
  public OPERACION_BORRAR:number = 3; 
  public operacionTabla:number = this.OPERACION_NULA;

  saveModel = new EventEmitter();
  public showSave:boolean;
  listaActiIng:any;
  model:DDocumento;
  mensajeTabla = "Algunos campos fueron sugeridos por el sistema(basados en su información exógena). Edite, agregue o elimine ítems de ser necesario.";
  mensajeForm = "Este ítem fue sugerido con base a su información exógena. Al editarlo no esta editando su exógena, simplemente no será usada para este ítem.";
  constructor(
    public dutilidades:DOperacionesMatematicasServicio, 
    public dNotificacionServicio: DNotificacionServicio,
    public dialogRef: MatDialogRef<IngresosComercianteModalComponent>,
    private _componentFactory: ComponentFactoryService,
    private _sugeridaSingletonService: SugeridaSingletonService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { 
    super(stepsList, DAyudasFormularioNoExperto.AYUDAS_FORMULARIO);
    this.model = this.data.model;
    //this.model = this.data;
    //console.log(this.model);
  }

  ngOnInit() {
    const isArray = Array.isArray(this.model.doc.cuerpo.cs_id_648);
    if(isArray){
      this.model.doc.cuerpo.cs_id_648 = "0";
    }

    this.inicializeModelo();
    this.inicializeForm();
    this.initializeTablaDesdeModelo();
    this.initializeTablaDesdeSugerida();
    this.validateShowSave();
   
    //console.log(this.model);

  }

  protected controlStep(direction: DirectionType): void {
  
  }
  

  protected inicializeForm(){
    this.modelForm = new Form1();
    this.modelForm.id=0;
    this.modelForm.informante="";
    this.modelForm.actividad="0";
    this.modelForm.valor="0";
    this.modelForm.retencion="0";
    this.modelForm.devoluciones="0";
    this.modelForm.origen="";

  }
  
  protected inicializeModelo(){
    if(this.model.doc.cuerpo.cc_id_339 == undefined){

      this.model.doc.cuerpo.cc_id_339 = []; //informante
      this.model.doc.cuerpo.cc_id_341 = []; //actividad
      this.model.doc.cuerpo.cc_id_340 = []; //origen
      this.model.doc.cuerpo.cc_id_342 = []; //valor
      this.model.doc.cuerpo.cc_id_346 = []; //retencion
      this.model.doc.cuerpo.cc_id_347 = []; //devoluciones
      this.model.doc.cuerpo.cs_id_343 = "0";
   
    }  
  }

 

  public operacionCs343(){ 
    let suma = "0";
    for(let i=0; i<this.dataSourceBody.length; i++){
        suma = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA,this.dataSourceBody[i].valor, suma);
    
    }
     
      const sumaCs371 = this.obtenerSumaRentaNoLaboral();
      const cs648 = this.model.doc.cuerpo.cs_id_648 ? this.model.doc.cuerpo.cs_id_648 : "0";
      const suma1 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA,sumaCs371, cs648);
      const sumaCc538 = this.obtenerSumaAnio2021();
   //   console.log(sumaCs371);
      const suma2 =  this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA,suma1, sumaCc538);
      this.model.doc.cuerpo.cs_id_343 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA,suma, suma2);
     // console.log(this.model.doc.cuerpo.cs_id_343);

  }

  protected obtenerSumaAnio2021(){
    let totalSum = "0";
    if(this.model.doc.cuerpo.cc_id_547 != undefined && this.model.doc.cuerpo.cc_id_547 != null
      && this.model.doc.cuerpo.cc_id_547.length > 0){

      const posicionesAnio2021 = this.model.doc.cuerpo.cc_id_547.reduce((acc, item, index) => {
      
        if (item.v > "2021") {
            acc.push(index);
        }
        return acc;
      }, []);

      const valoresItemsAnio20211 = posicionesAnio2021.map(pos => this.model.doc.cuerpo.cc_id_538[pos]);
      const valoresV = valoresItemsAnio20211.map(item => item.v);
    
      
      for(let i=0; i<valoresV.length; i++){
        totalSum = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA,valoresV[i], totalSum);
      } 
  
    };
   
    return totalSum;
  }

  protected obtenerSumaRentaNoLaboral(){
    let totalSum = "0";
    if(this.model.doc.cuerpo.cc_id_370 != undefined && this.model.doc.cuerpo.cc_id_370 != null
      && this.model.doc.cuerpo.cc_id_370.length > 0){
        const itemsRentaNoLaboral = this.model.doc.cuerpo.cc_id_370
        .filter(item => item.v === "4")
        .map(item => item.it);

        const valoresItemsRentaNoLaboral = this.model.doc.cuerpo.cc_id_371
        .filter(item => itemsRentaNoLaboral.includes(item.it))
        .map(item => item.v);
      
        for(let i=0; i<valoresItemsRentaNoLaboral.length; i++){
          totalSum = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA,valoresItemsRentaNoLaboral[i], totalSum);
        } 
    
    };
   
    return totalSum;
  }
  
  //////////////////////

  protected initializeTablaDesdeModelo(){
    this.dataSourceBody = [];
    for(let i=0; i<this.model.doc.cuerpo.cc_id_339.length; i++){
      this.modelForm.id=i;
      this.modelForm.informante=this.model.doc.cuerpo.cc_id_339[i].v;
      this.modelForm.origen=this.model.doc.cuerpo.cc_id_340[i].v;
      this.modelForm.actividad=this.model.doc.cuerpo.cc_id_341[i].v;
      if(this.listaActiIng && this.listaActiIng.length>0)
        this.modelForm.actividadNombre=this.listaActiIng[this.model.doc.cuerpo.cc_id_341[i].v-1].nombre;
      this.modelForm.valor=this.model.doc.cuerpo.cc_id_342[i].v;
      this.modelForm.retencion=this.model.doc.cuerpo.cc_id_346[i].v;
      this.modelForm.devoluciones=this.model.doc.cuerpo.cc_id_347[i].v;

      this.dataSourceBody.push(this.modelForm);
      this.inicializeForm();
    }
  }

protected initializeTablaDesdeSugerida()
{
  let indexModel = this.model.doc.cuerpo.cc_id_339.length;

  if(indexModel==0){
    const fieldsRecovery = ['VAR_1184','VAR_2587','VAR_2371','VAR_3651','VAR_2008','VAR_2493','VAR_2459','VAR_2480','VAR_2007','VAR_2479','VAR_2398','VAR_3659','VAR_2096','VAR_5151','VAR_5156','VAR_1738','VAR_3675','VAR_2016','VAR_2489','VAR_2016','VAR_2279','VAR_2410','VAR_2279','VAR_3665','VAR_2018','VAR_2491','VAR_2018','VAR_4807','VAR_2374','VAR_2593','VAR_2374','VAR_4737','VAR_2373','VAR_2589','VAR_2373','VAR_4812','VAR_4802','VAR_2276','VAR_2238','VAR_1269','VAR_1716','VAR_1717','VAR_1722','VAR_1723','VAR_1731','VAR_1737','VAR_1745','VAR_2076','VAR_1755','VAR_2079','VAR_4472'];
    const resData = this._sugeridaSingletonService.getDataArrFromMap(fieldsRecovery);
    
    const grupos=[
      ['VAR_1184','VAR_2587','VAR_2371','VAR_3651','VAR_2008','VAR_2493','VAR_2459','VAR_2480','VAR_2007','VAR_2479','VAR_2398','VAR_3659','VAR_2096','VAR_5151','VAR_5156','VAR_1738','VAR_3675','VAR_2016','VAR_2489','VAR_2016','VAR_2279','VAR_2410','VAR_2279','VAR_3665','VAR_2018','VAR_2491','VAR_2018','VAR_4807','VAR_2374','VAR_2593','VAR_2374','VAR_4737','VAR_2373','VAR_2589','VAR_2373','VAR_4812','VAR_4802','VAR_2276','VAR_2238'],
      ['VAR_1269','VAR_1716','VAR_1717','VAR_1722','VAR_1723','VAR_1731','VAR_1737','VAR_1745','VAR_2076','VAR_1755','VAR_2079','VAR_4472']
    ];

    if(resData)
      {
        for(let i=0; i<resData.length; i++){
          for(let j=0; j<resData[i].item.value.length; j++){
            
            this.modelForm.id=indexModel;
            this.modelForm.informante=resData[i].item.numNitInformante[j]+"/"+resData[i].item.nomRazonSocialInformante[j];
            this.modelForm.origen="0";
            if(resData[i].key=="VAR_1184"){
              this.modelForm.actividad= "1"; 
            }
            if(resData[i].key=="VAR_2587" || resData[i].key=="VAR_2371" || resData[i].key=="VAR_3651" || resData[i].key=="VAR_2008" || resData[i].key=="VAR_2493" 
              || resData[i].key=="VAR_2459" || resData[i].key=="VAR_2480" || resData[i].key=="VAR_2007" || resData[i].key=="VAR_2479" || resData[i].key=="VAR_2398" 
              || resData[i].key=="VAR_3659" || resData[i].key=="VAR_2096" || resData[i].key=="VAR_5151" || resData[i].key=="VAR_5156" || resData[i].key=="VAR_1738" 
              || resData[i].key=="VAR_3675" || resData[i].key=="VAR_2016" || resData[i].key=="VAR_2489" || resData[i].key=="VAR_2016" || resData[i].key=="VAR_2279" 
              || resData[i].key=="VAR_2410" || resData[i].key=="VAR_2279" || resData[i].key=="VAR_3665" || resData[i].key=="VAR_2018" || resData[i].key=="VAR_2491" 
              || resData[i].key=="VAR_2018" || resData[i].key=="VAR_4807" || resData[i].key=="VAR_2374" || resData[i].key=="VAR_2593" || resData[i].key=="VAR_2374" 
              || resData[i].key=="VAR_4737" || resData[i].key=="VAR_2373" || resData[i].key=="VAR_2589" || resData[i].key=="VAR_2373" || resData[i].key=="VAR_4812" 
              || resData[i].key=="VAR_4802" || resData[i].key=="VAR_2276" || resData[i].key=="VAR_2238"){
              this.modelForm.actividad= "5"; 
            }

            if(this.listaActiIng[Number(this.modelForm.actividad)-1])
              this.modelForm.actividadNombre= this.listaActiIng[Number(this.modelForm.actividad)-1].nombre; 

            let itemGrupoFormPorEditar:Form1 = null;

            //0. Buscar el idGrupo al que corresponde la variable. (Siempre lo debe encontrar)
            let idGrupo:number = -1;
            for(let k=0;k<grupos.length;k++){
              if(grupos[k].includes(resData[i].key)){
                idGrupo=k;
                break;
              }
            }

            //1. El nit ya existe? NO ->1:Agregar
            if(this.dataSourceBody.find((el)=>{
              return el.controlSugeridaForm.numNitReportante == resData[i].item.numNitInformante[j]    
            })==undefined){
              itemGrupoFormPorEditar = null;
            }else{

              //2. Trae array de solo los del NIT
              let dataSourceBodyPorNitRep = this.dataSourceBody.filter((el)=>{
                if(el.controlSugeridaForm.numNitReportante == resData[i].item.numNitInformante[j]){
                  return el;
                }
              });

              //3. Recorrer array de solo los del NIT
              for(let k=0;k<dataSourceBodyPorNitRep.length;k++){
                //En el registro existe una variable del GRUPO? 
                //  - NO: Debe Editar el registro y deja de buscar
                //  - SI: Siga buscando (al final si todos tienen entonces debe Agregar nuevo registro por que esta todo ocupado)
                let dataGrupo = dataSourceBodyPorNitRep[k].controlSugeridaForm.grupos.find((el=>{return el.idGrupo==idGrupo}));
                if(!dataGrupo){
                  itemGrupoFormPorEditar = dataSourceBodyPorNitRep[k];
                  break;
                }
              }

            }
            
            //4. Si la variable 'itemGrupoFormPorEditar' tiene valor entonces EDITA, si no AGREGA
            if(itemGrupoFormPorEditar){
              this.dataSourceBody = this.dataSourceBody.filter((itemModelForm)=>{
                if(itemModelForm.id == itemGrupoFormPorEditar.id){
                  itemModelForm.controlSugeridaForm.grupos.push({idGrupo:idGrupo,variable:resData[i].key});
                  itemModelForm = this.asignarVariablesSugeridasCondicionadas(itemModelForm, idGrupo, String(resData[i].item.value[j]));
                }
                return itemModelForm;
              });
            }else{
              this.modelForm.controlSugeridaForm = new ControlSugeridaForm();
              this.modelForm.controlSugeridaForm.numNitReportante = resData[i].item.numNitInformante[j];
              this.modelForm.controlSugeridaForm.grupos = new Array<ControlGrupoVariables>();
              this.modelForm.controlSugeridaForm.grupos.push({idGrupo:idGrupo,variable:resData[i].key});
              this.redondearFormData();
              this.modelForm = this.asignarVariablesSugeridasCondicionadas(this.modelForm, idGrupo, String(resData[i].item.value[j]));
              this.dataSourceBody.push(this.modelForm);
              this.inicializeForm();
              indexModel++;
            }
          }
        }
      }
  }
  this.operacionCs343();
}


private asignarVariablesSugeridasCondicionadas(itemModelForm: Form1, idGrupo:number, valor:string){
  switch(idGrupo){//Depende de la variable array grupos
    case 0:
      itemModelForm.valor=String(valor);
    break;
    case 1:
      itemModelForm.retencion=String(valor);
    break;
    default:
    break;
  }
  return itemModelForm;
}

  public editModeloDesdeForm(){
   
    this.model.doc.cuerpo.cc_id_339[this.modelForm.id].v=this.modelForm.informante;
    this.model.doc.cuerpo.cc_id_340[this.modelForm.id].v=this.modelForm.origen.toString();
    this.model.doc.cuerpo.cc_id_341[this.modelForm.id].v=this.modelForm.actividad.toString();
    this.model.doc.cuerpo.cc_id_342[this.modelForm.id].v=this.modelForm.valor.toString();
    this.model.doc.cuerpo.cc_id_346[this.modelForm.id].v=this.modelForm.retencion.toString();
    this.model.doc.cuerpo.cc_id_347[this.modelForm.id].v=this.modelForm.devoluciones.toString();

  }

  public addToModeloDesdeForm(){
    let i= this.modelForm.id+1;
    this.model.doc.cuerpo.cc_id_339.push({it: i, v:this.modelForm.informante});
    this.model.doc.cuerpo.cc_id_340.push({it: i, v:this.modelForm.origen.toString()});
    this.model.doc.cuerpo.cc_id_341.push({it: i, v:this.modelForm.actividad.toString()});
    this.model.doc.cuerpo.cc_id_342.push({it: i, v:this.modelForm.valor.toString()});
    this.model.doc.cuerpo.cc_id_346.push({it: i, v:this.modelForm.retencion.toString()});
    this.model.doc.cuerpo.cc_id_347.push({it: i, v:this.modelForm.devoluciones.toString()});

  }

  public deleteOnModel(index:number){
    this.model.doc.cuerpo.cc_id_339.splice(index,1);
    this.model.doc.cuerpo.cc_id_340.splice(index,1);
    this.model.doc.cuerpo.cc_id_341.splice(index,1);
    this.model.doc.cuerpo.cc_id_342.splice(index,1);
    this.model.doc.cuerpo.cc_id_346.splice(index,1);
    this.model.doc.cuerpo.cc_id_347.splice(index,1);


    //reenumerear it
    for(let i=0;i<this.model.doc.cuerpo.cc_id_339.length;i++){
      this.model.doc.cuerpo.cc_id_339[i].it=i+1;
      this.model.doc.cuerpo.cc_id_340[i].it=i+1;
      this.model.doc.cuerpo.cc_id_341[i].it=i+1;
      this.model.doc.cuerpo.cc_id_342[i].it=i+1;
      this.model.doc.cuerpo.cc_id_346[i].it=i+1;
      this.model.doc.cuerpo.cc_id_347[i].it=i+1;

    }
  }

  public validateFormCompleted():boolean{
    return this.modelForm.actividad==undefined || this.modelForm.actividad==null  || this.modelForm.actividad=="0" || 
        this.modelForm.valor==undefined || this.modelForm.devoluciones==null || 
         this.modelForm.retencion==undefined || this.modelForm.retencion==null ||
         this.modelForm.devoluciones==undefined || this.modelForm.devoluciones==null ||      
        this.modelForm.origen==undefined || this.modelForm.origen==null 
  }

  public redondearFormData(){
    this.modelForm.valor=this.dutilidades.redondearValorMoneda(this.modelForm.valor.toString(),true);
    this.modelForm.retencion=this.dutilidades.redondearValorMoneda(this.modelForm.retencion.toString(),true);
    this.modelForm.devoluciones=this.dutilidades.redondearValorMoneda(this.modelForm.devoluciones.toString(),true);

  }

  public calcularValoresForm(conservarArt?:boolean){
    this.redondearFormData();

  }

  saveItem(): void {
    if(this.validateFormCompleted()){
      let dialogError = this.dNotificacionServicio.mostrarDialogoError("Debe diligenciar todos los campos para agregar un nuevo registro" );
      return;
    }else{
      this.redondearFormData();
     // this.modelForm.origen = (this.modelForm.origen == "0" || this.modelForm.origen == "1") && this.operacionTabla==this.OPERACION_EDITAR ? "1" : "2";
      if (this.operacionTabla==this.OPERACION_EDITAR){
        
        this.modelForm.actividadNombre = this.listaActiIng[Number(this.modelForm.actividad)-1].nombre;

        if(this.modelForm.origen=="0"){ 
          this.modelForm.origen = "1";
        }
        this.dataSourceBody.forEach((el)=>{
          if(el.id == this.modelForm.id){
            el=this.modelForm;
          }
        });
      }else if (this.operacionTabla==this.OPERACION_AGREGAR){ //agregando nuevo por el contribuyente
        this.modelForm.id = this.model.doc.cuerpo.cc_id_339.length;
        this.modelForm.origen = "2";
      //  this.modelForm.reportante = "Contribuyente";
        this.modelForm.actividadNombre = this.listaActiIng[Number(this.modelForm.actividad)-1].nombre;
        this.dataSourceBody.push(this.modelForm);
        //this.addToModeloDesdeForm();
      }
      //Recalcular y reinicializar
      this.operacionCs343();
      this.inicializeForm();
      this.operacionTabla=this.OPERACION_NULA;
    } 
  }

  eventTable($event: string): void {
    if($event === 'add') this.operacionTabla=this.OPERACION_AGREGAR;
    if($event === 'edit') this.operacionTabla=this.OPERACION_EDITAR;
    if($event === 'delete') this.operacionTabla=this.OPERACION_BORRAR;
    this.operacionCs343();
  }

  updateItemSelected($event: any): void {
    let index = $event;
    if(this.operacionTabla==this.OPERACION_EDITAR){//editando
      this.modelForm = this.dataSourceBody[index];
   
    }
    if(this.operacionTabla==this.OPERACION_BORRAR){//borrando
      //this.deleteOnModel(index);
      this.operacionTabla=this.OPERACION_NULA;
    }
  }
  
  cancel(): void {
    this.inicializeForm();
    this.operacionTabla=this.OPERACION_NULA;
  }

  
  
  //Aplica para revisar si hay preguntas que se habilitaron con una previa respuesta SI en el modal
  protected validateHasModalValues(indexQuestion:number): boolean{
    let hasValues:boolean = false;
    return hasValues;
  }

  //Aplica normalmente si se cambia el valor SI a NO en una pregunta del modal y deben eliminarse valores los valores previamente diligenciados
  protected cleanModalValues(indexQuestionModal:number){
    
  }



  
  protected obtenerCasIndicadorAvance():string{
    if(this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]==undefined){
      this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]="0";
    }
    return this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE];
  }

  protected validateShowSave(){
    if(this.indexStepper==this.stepsList.length-1 || this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]==VAL_INDICADOR_COMPLETO){ this.showSave=true };
  }

  public closeModal(){
    this.initializeTablaDesdeModelo();
    this.operacionCs343();
    this.dialogRef.close("");
  }
  public guardar(){
    //Limpiar modelo y agregar el contenido de la tabla
     //Limpiar modelo y agregar el contenido de la tabla
    this.model.doc.cuerpo.cc_id_339 = undefined;
    this.inicializeModelo();
    for(let i=0; i<this.dataSourceBody.length; i++){
      this.modelForm = this.dataSourceBody[i];
      this.addToModeloDesdeForm();
    }
    this.operacionCs343();
    
    //console.log(this.model) 
    this.saveModel.emit(true); 
    this.closeModal(); 
  }
  public borrarTabla(){
    this.dataSourceBody = [];
  }

  protected cleanInput(nameInput: string): void {
    if(this.modelForm[nameInput] == "0" || this.modelForm[nameInput] == "")
      this.modelForm[nameInput] = '';
  }



}



// WEBPACK FOOTER //
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/formulario-no-experto/secciones/modales/ingresos/ingresos-comerciante/ingresos-comerciante-modal.component.ts